// billing-plugin/common/schemas/collections/billableFeatures.js
import { z } from "zod";
import  RecurrenceRuleSchema  from "./recurrenceRule.js";

const BillableFeatureSchema = z.object({
    _id: z.string().optional(),
    featureKey: z.string().describe("Unique key for the feature, e.g., 'UserSeat', 'PhoneNumberLease'."),
    name: z.string().describe("Human-readable name, e.g., 'User Seat'."),
    description: z.string().optional(),
    
    billerName: z.string().describe("The class name of the Biller responsible for calculating charges."),
    billerConfig: z.string().optional().describe("Default configuration for the biller."),
    
    oneTimeFee: z.number().int().optional().nullable().describe("Default one-time fee in cents."),
    recurringFee: z.number().int().optional().nullable().describe("Default recurring fee in cents."),
    
    freeUnits: z.number().int().default(0).describe("Default number of free units."),
    maxUnits: z.number().int().positive().optional().nullable().describe("Default hard cap on usage."),
    
    usageRefreshRule: RecurrenceRuleSchema.describe("The rule defining when the 'usedUnits' counter resets."),
    
    trackIndividually: z.boolean().default(false).describe("If true, a 'chargeable' record is created for each instance of this feature."),
    isArchived: z.boolean().default(false),
    
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default BillableFeatureSchema;